import { Component, Inject, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { ProcedureDetailsComponent } from './registration/details/procedure-details.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'page-procedure',
  templateUrl: './procedure.component.html',
  styleUrls: ['./procedure.component.scss'],
})
export class ProcedureComponent extends BaseComponent implements OnInit {
  constructor(
    private healthcareService: ProcedureService,
    private injector: Injector
  ) {
    super(injector);
  }

  public title = 'Exames/Procedimentos';
  public procedures: Healthcareservice[] = [];

  public get procedureActive(): Healthcareservice[] {
    const procedures = [...this.procedures];
    return procedures.filter((item: Healthcareservice) => !!item.status);
  }

  public get procedureInactive(): Healthcareservice[] {
    const procedures = [...this.procedures];
    return procedures.filter((item: Healthcareservice) => !item.status);
  }

  ngOnInit(): void {
    this.getProcedures();
  }

  transformToFormData(healthcareserviceData: any): any {
    return {
      healthcareservice_id: healthcareserviceData.healthcareservice_id,
      name: healthcareserviceData.name,
      description: healthcareserviceData.description,
      extraDetails: healthcareserviceData.extraDetails,
      type: healthcareserviceData.type[0].coding[0].display,
      price_low: parseInt(healthcareserviceData?.valueRange?.low?.value),
      price_high: parseInt(healthcareserviceData?.valueRange?.high?.value),
      status: healthcareserviceData.status,
      specialty: healthcareserviceData.specialty[0].coding[0].display,
      comment: healthcareserviceData.comments,
      appointmentRequired: healthcareserviceData.appointmentRequired,
    };
  }

  getProcedures() {
    const organizationId = this.getUserLogged().id;

    this.healthcareService.listByOrganizations(organizationId).subscribe({
      next: (healthcareservice: Healthcareservice[]) => {
        this.procedures = healthcareservice;
      },
      error: (error: HttpErrorResponse) => {
        console.log('Falha ao buscar Healthcare');
      },
    });
  }

  openProcedureDatail(procedure: Healthcareservice) {
    const data = {
      title: procedure.name,
      param: { procedure: procedure },
    };

    this.dialog.openComponentDialog(ProcedureDetailsComponent, data)
      .subscribe({
        next: (res: any) => {
          this.getProcedures();
        },
      });
     
  }

  openProcedureForm() {
    this.dialog.openProcedureFormDialog({
      component: 'procedure-form',
      param: { mode: 'CREATE' },
    }) .subscribe({
        next: (res: any) => {
          this.getProcedures();
        },
      });;
  }
}
